import styled from '@emotion/styled';
import BenefitCard, { Props as BenefitCardProps } from '.';
import { primary } from '@styles/Colors';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useEffect, useRef } from 'react';

const BenefitCardListWrapper = styled.div`
  width: 100%;
  max-width: 1080px;

  .swiper-slide {
    width: auto;
  }

  .swiper-pagination {
    position: static;
    padding-top: 40px;
  }

  .swiper-pagination-bullet-active {
    background: ${primary.gray};
  }
  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
  }
`;

const benefitCardList: BenefitCardProps[] = [
  {
    hashTags: ['업무'],
    title: '장비지원',
    content:
      '직군에 따라 맥북 / 그램 노트북과 함께 듀얼모니터가 지급됩니다. 각 환경에 맞는 키보드와 마우스 혹은 트랙패드도 함께 지원하고 있습니다.',
    image: {
      src: '/assets/images/career_image_01.png',
      width: 214,
      height: 171,
    },
  },
  {
    hashTags: ['업무'],
    title: '유연근무 지원',
    content:
      '오전 7~10시 자율출근을 진행하고 있으며, 11시~4시까지는 협업시간입니다.\n또한 주 2회 재택근무를 지원하고 있어 원하는 곳에서 자유롭게 근무할 수 있습니다.',
    image: {
      src: '/assets/images/career_image_02.png',
      width: 211,
      height: 182,
    },
  },
  {
    hashTags: ['업무'],
    title: '교육 지원',
    content:
      '업무에 필요한 온 / 오프라인 교육을 지원하고 있습니다.\n강의나 서적, 컴퍼런스 참여 등 자유로운 형태로 지원하고 있습니다.',
    image: {
      src: '/assets/images/career_image_03.png',
      width: 238,
      height: 169,
    },
  },
  {
    hashTags: ['라이프'],
    title: '연차 24일 지원',
    content:
      '마켓오브메테리얼 구성원이라면 연 24개의 연차를 가지고 있으며,\nflex에 등록후 자유롭게 사용할 수 있습니다.',
    image: {
      src: '/assets/images/career_image_04.png',
      width: 273,
      height: 167,
    },
  },
  {
    hashTags: ['라이프'],
    title: '주차비 / 주거비 지원',
    content:
      '차량으로 출퇴근하는 구성원에게는 주차비를 지원하고 있으며,\n차량이 없는 구성원에게는 주거비 15만원을 지원하고 있습니다.',
    image: {
      src: '/assets/images/career_image_05.png',
      width: 321,
      height: 188,
    },
  },
  {
    hashTags: ['라이프'],
    title: '장기근속 지원',
    content:
      '장기근속 1년에는 호캉스, 3년에는 제주도 여행, 5년에는 해외여행 지원하고 있으며, 근속 10년차에는 1년 유급휴가를 지원하고 있습니다.',
    image: {
      src: '/assets/images/career_image_06.png',
      width: 359,
      height: 169,
    },
  },
  {
    hashTags: ['라이프'],
    title: '건강검진 지원',
    content: '건강을 지킬 수 있도록 연 1회 정밀 건강검진을 지원하고 있습니다.',
    image: {
      src: '/assets/images/career_image_07.png',
      width: 220,
      height: 179,
    },
  },
  {
    hashTags: ['기타'],
    title: '경조사 지원',
    content: '명절 10만원 상품권과 결혼, 출산, 부고 등 해당 경조사비와\n휴가를 함께 지원하고 있습니다.',
    image: {
      src: '/assets/images/career_image_08.png',
      width: 384,
      height: 164,
    },
  },
  {
    hashTags: ['기타'],
    title: '기타',
    content: '모든 구성원은 단체 질병 / 상해 보험에 가입되어 있으며,\n협의 후 스톡옵션을 제공하고 있습니다.',
    image: {
      src: '/assets/images/career_image_09.png',
      width: 239,
      height: 177,
    },
  },
];

type Props = {
  categoryName?: string;
};

export default function BenefitCardList({ categoryName }: Props) {
  const swiperRef = useRef<SwiperRef>(null);

  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideTo(0);
    }
  }, [categoryName]);

  return (
    <>
      <BenefitCardListWrapper>
        <Swiper
          ref={swiperRef}
          spaceBetween={24}
          slidesPerView={'auto'}
          modules={[/* Navigation,  */ Pagination]}
          pagination={{ clickable: true }}>
          {(categoryName
            ? benefitCardList.filter((item) => item.hashTags.includes(categoryName))
            : benefitCardList
          ).map((item, index) => (
            <SwiperSlide key={index}>
              <BenefitCard key={index} {...item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </BenefitCardListWrapper>
    </>
  );
}
